export enum SessionStorageKeys {
  Visited = 'visited',
}
